import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_NHOM_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function khachHangNhomUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.KHACHHANG_NHOM_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function* khachHangNhomDetailRequestFlow({payload, callback}) {
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.khachHangNhomDetailSuccess())
    if (callback) {
      yield call(callback, results.data)
    }
  } catch (error) {
    yield put(brActions.khachHangNhomDetailError(error))
  }
}

function* khachHangNhomUpdateRequestFlow({payload, callback}) {
  try {
    // grab the client from our action
    const {code, data, message} = yield call(khachHangNhomUpdateRequestApi, payload)

    // dispatch the action with our widgets!
    if (code != 200) {
      return put(brActions.khachHangNhomUpdateError(message))
    }
    yield put(brActions.khachHangNhomUpdateSuccess(data));
    if (typeof callback == 'function') {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(brActions.khachHangNhomUpdateError(error))
  }
}

function* khachHangNhomUpdateInfoFlow({payload, callback}) {
  try {
    const request = axiosApi().post(
      Constants.KHACHHANG_NHOM_UPDATE_NHOM_KH_API,
      payload
    )
  
    // grab the client from our action
    const {code, data, message} = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    if (code != 200) {
      return put(brActions.updateNhomKhachHangInfoError(message))
    }
    yield put(brActions.updateNhomKhachHangInfoSuccess());
    if (typeof callback == 'function') {
      yield call(callback, data)
    }
  } catch (error) {
    yield put(brActions.updateNhomKhachHangInfoError(error))
  }
}

function* khachHangNhomWatcher() {
  yield [
    takeLatest(Constants.KHACHHANG_NHOM_DETAIL_REQUESTING, khachHangNhomDetailRequestFlow),
    takeLatest(Constants.KHACHHANG_NHOM_UPDATE_REQUESTING, khachHangNhomUpdateRequestFlow),
    takeLatest(Constants.KHACHHANG_NHOM_UPDATE_NHOM_KH, khachHangNhomUpdateInfoFlow),
  ]
}

export default khachHangNhomWatcher



// WEBPACK FOOTER //
// ./src/views/KhachHangNhom/sagas.js